import { render, staticRenderFns } from "./LabelGeneratorsTable.vue?vue&type=template&id=43bb51a9&"
import script from "./LabelGeneratorsTable.vue?vue&type=script&lang=ts&"
export * from "./LabelGeneratorsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports